import React from 'react'

import { MenuItem, TextField } from '@mui/material'
import { observer } from 'mobx-react'

import type { MsaViewModel } from '../../model.ts'

const MultiAlignmentSelector = observer(function ({
  model,
}: {
  model: MsaViewModel
}) {
  const { currentAlignment, alignmentNames } = model
  // names (gf.DE) can repeat, so disambiguate duplicates by occurrence to get a
  // collision-free key tied to content rather than position: this survives the
  // list being replaced (new file) without React reusing stale MenuItem DOM.
  // value stays the index because selection is positional in the model.
  const seen = new Map<string, number>()
  return alignmentNames.length > 0 ? (
    <TextField
      select
      variant="outlined"
      value={currentAlignment}
      size="small"
      onChange={event => {
        model.setCurrentAlignment(+event.target.value)
        model.setScrollX(0)
        model.setScrollY(0)
      }}
    >
      {alignmentNames.map((option, index) => {
        const n = seen.get(option) ?? 0
        seen.set(option, n + 1)
        return (
          <MenuItem key={n === 0 ? option : `${option} ${n}`} value={index}>
            {option}
          </MenuItem>
        )
      })}
    </TextField>
  ) : null
})
export default MultiAlignmentSelector
